function BackgroundDecor() {
  return (
    <>
      <div className="pointer-events-none absolute inset-x-0 top-0 h-[540px] bg-gradient-to-b from-brand-mist via-brand-bg to-transparent" />
      <div className="pointer-events-none absolute -right-20 top-24 h-64 w-64 rounded-full bg-brand-petal/50 blur-3xl" />
      <div className="pointer-events-none absolute -left-16 top-60 h-56 w-56 animate-float rounded-full bg-brand-sage/70 blur-3xl" />
    </>
  );
}

export default BackgroundDecor;